import { useEffect } from 'react';

declare global {
  interface Window {
    newrelic?: {
      setUserId?: (value: string | null, resetSession?: boolean) => void;
    };
  }
}

const useNewRelic = (companyReservationCode?: string) => {
  useEffect(() => {
    if (!window.newrelic) {
      return;
    }

    if (!companyReservationCode) {
      window.newrelic.setUserId?.(null, true);
      return;
    }

    window.newrelic.setUserId?.(`guest-${companyReservationCode}`, true);
  }, [companyReservationCode]);
};

export { useNewRelic };
